import React, { useCallback, useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Autoplay from 'embla-carousel-autoplay';
import { motion } from 'framer-motion';

export const LogoCarousel = ({ logos, title, className = '' }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { 
      loop: true, 
      align: 'start',
      dragFree: true,
      containScroll: 'trimSnaps'
    },
    [Autoplay({ delay: 3000, stopOnInteraction: false, stopOnMouseEnter: true })]
  );

  return (
    <div className={className}>
      {title && (
        <h3 className="text-center text-sm font-medium text-muted-foreground uppercase tracking-wider mb-8">
          {title}
        </h3>
      )}
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex gap-8 md:gap-12">
          {logos.map((logo, index) => (
            <div
              key={`${logo.name}-${index}`}
              className="flex-shrink-0 flex items-center justify-center min-w-[120px] md:min-w-[160px] h-16 md:h-20"
            >
              {logo.logo ? (
                <img
                  src={logo.logo}
                  alt={logo.name}
                  className="max-h-10 md:max-h-14 w-auto object-contain logo-carousel-item"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
              ) : null}
              <div
                className={`${logo.logo ? 'hidden' : 'flex'} items-center justify-center px-4 py-2 bg-secondary rounded-lg`}
                style={{ display: logo.logo ? 'none' : 'flex' }}
              >
                <span className="text-sm font-medium text-muted-foreground whitespace-nowrap">
                  {logo.name}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

// Infinite scroll marquee variant
export const LogoMarquee = ({ logos, title, className = '' }) => {
  return (
    <div className={className}>
      {title && (
        <h3 className="text-center text-sm font-medium text-muted-foreground uppercase tracking-wider mb-8">
          {title}
        </h3>
      )}
      <div className="relative overflow-hidden">
        <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-background to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-background to-transparent z-10" />
        
        <div className="flex animate-marquee">
          {[...logos, ...logos].map((logo, index) => (
            <div
              key={`${logo.name}-${index}`}
              className="flex-shrink-0 flex items-center justify-center mx-6 md:mx-10 h-16 md:h-20"
            >
              {logo.logo ? (
                <img
                  src={logo.logo}
                  alt={logo.name}
                  className="max-h-10 md:max-h-14 w-auto object-contain logo-carousel-item"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
              ) : null}
              <div
                className={`${logo.logo ? 'hidden' : 'flex'} items-center justify-center px-4 py-2 bg-secondary rounded-lg`}
                style={{ display: logo.logo ? 'none' : 'flex' }}
              >
                <span className="text-sm font-medium text-muted-foreground whitespace-nowrap">
                  {logo.name}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
